module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_mar_02-6bfb556e123ec211b62338c4a1c1c00c.png";